import { Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';

@Directive({
  selector: '[heading-info]',
})
export class HeadingInfoDirective implements OnInit, OnChanges {
  @Input() quoteInfo: any;

  public get orgName() {
    if (this.quoteInfo) {
      return (
        (this.quoteInfo.organisationName ? `${this.quoteInfo.organisationName}` : 'New Quote') +
        (this.quoteInfo.quoteRequestId ? ` (QUOTE ID ${this.quoteInfo.quoteRequestId})` : '')
      );
    }
    return null;
  }

  constructor(private el: ElementRef) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.el.nativeElement.textContent = this.orgName;
  }
}
